import { useLayoutEffect, useRef } from 'react';
import { Alert, Button, Spin } from '@arco-design/web-react';
import type { FormSessionToken } from '@jukun/platform-sdk/shell';
import { usePortalFormSessionManager, usePortalFormSessionSnapshot } from '../runtime/formSessionContext';

/** A display position only. Lifecycle actions are requested from the Shell manager. */
export function PortalFormSessionHost(props: { token?: FormSessionToken; onRetry?: () => void; className?: string }) {
  const manager = usePortalFormSessionManager();
  const snapshot = usePortalFormSessionSnapshot();
  const target = useRef<HTMLDivElement>(null);
  const active = snapshot.activeSession;
  const token = props.token;
  const matches = !!token && active?.token.sessionId === token.sessionId;
  useLayoutEffect(() => {
    if (!target.current || !token || !matches || active?.status === 'FAILED') return;
    const lease = manager.acquireDisplayLease(token, target.current);
    return lease.release;
  }, [manager, token?.sessionId, matches, active?.status === 'FAILED']);
  const failed = matches && active?.status === 'FAILED';
  return <div className={props.className} style={{ position: 'relative', height: '100%', minHeight: 0 }}>
    <div ref={target} style={{ height: '100%', minHeight: 0, visibility: matches && active?.status === 'READY' ? 'visible' : 'hidden' }} />
    {failed ? <Alert type="error" content="外部表单不可用，请重新加载"
      action={props.onRetry ? <Button type="primary" size="small" onClick={props.onRetry}>重新加载</Button> : undefined} />
      : !matches || active?.status === 'OPENING' ? <div className="portal-form-navigation-overlay" role="status">
        <Spin loading tip="正在准备表单..." />
      </div> : null}
  </div>;
}
